import * as faker from 'faker';

import {
    CheckStatus,
    CheckType,
    DocumentStatus,
    DocumentType,
    OrderStatus,
    ProductsPackageType,
    ProductsStatus,
} from 'core/dictionaries';

import {DashboardDateType, ProductTopRecord} from '../types';
import {ApiFilters} from '../types/api';
import {
    Factory,
    FactoryLineActivityRecord,
    FactoryLineStatisticsRecord,
    FactoryLineStatus,
} from '../types/profile';
import {formatDate} from '../utils/date';

export async function productsGrid(path: string, params: any): Promise<any[]> {
    const dataLength = faker.helpers.randomize([
        params.paging.pageSize,
        params.paging.pageSize + 1,
    ]);
    return new Promise((resolve) =>
        setTimeout(
            () =>
                resolve(
                    new Array(dataLength).fill(0).map(() => ({
                        productName: faker.name.title(),
                        markingCode: faker.random.uuid(),
                        status: ProductsStatus.INTRODUCED,
                        modifiedAt: faker.date.past().toISOString(),
                        packagingGroupType: ProductsPackageType.BOX,
                        manufacturer: faker.company.companyName(),
                    })),
                ),
            1000,
        ),
    );
}

export async function productsDetail(path: string) {
    return new Promise((resolve) =>
        setTimeout(
            () =>
                resolve({
                    markingCode: path.split('/').pop(),
                    fileLink: 'https://threejs.org/1212404600439927013L1MAjsOwt6F3G.png',
                    product: {
                        productName: faker.name.title(),
                        gtin: '111111111111',
                        brand: faker.company.companyName(),
                        manufacturer: faker.company.companyName(),
                    },
                    statuses: [
                        {
                            status: ProductsStatus.AGGREGATED,
                            operationTime: faker.date.past().toISOString(),
                            parentMarkingCode: faker.random.uuid(),
                        },
                    ],
                    operations: [
                        {
                            operationAction: DocumentType.AGGREGATE,
                            operationTime: faker.date.past().toISOString(),
                            orderId: faker.random.uuid(),
                            reportId: faker.random.uuid(),
                            counterparty: faker.company.companyName(),
                        },
                    ],
                }),
            1000,
        ),
    );
}

export async function receiptsDetail(id: string) {
    return new Promise((resolve) =>
        setTimeout(
            () =>
                resolve({
                    createdAt: '2021-06-21T05:30:27.021Z',
                    receiptId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    user: 'string',
                    retailAddress: 'string',
                    userInn: 'string',
                    taxationType: 0,
                    operator: 'string',
                    shiftNumber: 0,
                    dateTime: '2021-06-21T05:30:27.021Z',
                    fiscalDocumentNumber: 0,
                    fiscalDriveNumber: 'string',
                    productsTotalCount: 0,
                }),
            1000,
        ),
    );
}

export async function reportDetail() {
    return new Promise((resolve) =>
        setTimeout(
            () =>
                resolve({
                    createdAt: '2021-06-23T14:01:37.426Z',
                    reportId: 'f4f110cc-efff-425e-b5b8-bf6d41a76efc',
                    status: 'APPROVED',
                    reportType: 'UPD',
                    productsTotalCount: 11,
                    reportInfo: {
                        processedAt: '2021-03-11',
                        buyerLegalName: 'ООО Моя оборона',
                        sellerLegalName: 'ООО Вектор',
                        currency: 'Российский рубль',
                    },
                }),
            1000,
        ),
    );
}

export async function documentsGrid(path: string, params: any): Promise<any[]> {
    const dataLength = faker.helpers.randomize([
        params.paging.pageSize,
        params.paging.pageSize + 1,
    ]);

    return new Promise((resolve) =>
        setTimeout(
            () =>
                resolve(
                    new Array(dataLength).fill(0).map(() => ({
                        reportId: faker.random.uuid(),
                        createdAt: `${faker.date.past()}`,
                        owner: faker.company.companyName(),
                        status: faker.helpers.randomize([
                            DocumentStatus.CREATED,
                            DocumentStatus.PROCESSED,
                        ]),
                        type: faker.helpers.randomize([
                            DocumentType.AGGREGATE,
                            DocumentType.INTRODUCE,
                        ]),
                    })),
                ),
            1000,
        ),
    );
}

export async function checksGrid(path: string, params: any): Promise<any[]> {
    const dataLength = faker.helpers.randomize([
        params.paging.pageSize,
        params.paging.pageSize + 1,
    ]);

    return new Promise((resolve) =>
        setTimeout(
            () =>
                resolve(
                    new Array(dataLength).fill(0).map(() => ({
                        receiptId: faker.random.uuid(),
                        createdAt: `${faker.date.past()}`,
                        manufacturerName: faker.company.companyName(),
                        status: faker.helpers.randomize([CheckStatus.NEW, CheckStatus.CLOSED]),
                        operationType: faker.helpers.randomize([CheckType.COMING]),
                    })),
                ),
            1000,
        ),
    );
}

export async function ordersGrid(path: string, params: any): Promise<any[]> {
    const dataLength = faker.helpers.randomize([
        params.paging.pageSize,
        params.paging.pageSize + 1,
    ]);

    return new Promise((resolve) =>
        setTimeout(
            () =>
                resolve(
                    new Array(dataLength).fill(0).map(() => ({
                        orderId: faker.random.uuid(),
                        closedAt: `${faker.date.past()}`,
                        createdAt: `${faker.date.past()}`,
                        totalMarkingCodes: faker.random.number(),
                        status: faker.helpers.randomize([
                            OrderStatus.APPROVED,
                            OrderStatus.READY,
                            OrderStatus.DECLINED,
                            OrderStatus.CLOSED,
                        ]),
                    })),
                ),
            1000,
        ),
    );
}

const randomInt = (min: number, max: number): number =>
    Math.floor(min + Math.random() * (max + 1 - min));

// export async function fetchProductDynamicStatistics(
//     from: Date,
//     to: Date,
//     dateType: DashboardDateType,
// ): Promise<ProductDynamicResponse> {
//     const data: ProductDynamicRecord[] = [];
//     const a: Array<{x: string; y: number; date: Date}> = [];

//     if (dateType === DashboardDateType.Day) {
//         for (let d = new Date(from); d < to; d.setTime(d.getTime() + 60 * 60 * 1000)) {
//             a.push({
//                 x: formatDate(d, 'HH:mm'),
//                 y: randomInt(0, 1e11),
//                 date: new Date(d),
//             });
//         }
//     } else {
//         let range = 1;
//         if (dateType === DashboardDateType.Quarter) range = 7;
//         for (let d = new Date(from); d <= to; d.setDate(d.getDate() + range)) {
//             a.push({
//                 x: formatDate(d, 'dd.MM'),
//                 y: randomInt(0, 1e11),
//                 date: new Date(d),
//             });
//         }
//     }

//     data.push({
//         id: 'realized',
//         data: a,
//     });

//     const total = randomInt(0.2e7, 3e8);

//     return new Promise((resolve) => {
//         setTimeout(() => {
//             resolve({
//                 total,
//                 data,
//             });
//         }, 500);
//     });
// }

// export async function fetchProductStatusStatistics(
//     from: Date,
//     to: Date,
//     dateType: DashboardDateType,
// ): Promise<ProductStatusRecord[]> {
//     const data: ProductStatusRecord[] = [];

//     data.push({
//         id: 'issued',
//         value: randomInt(1e6, 1e7),
//     });

//     data.push({
//         id: 'sold',
//         value: randomInt(0.2e6, 3e6),
//     });

//     data.push({
//         id: 'writtenOff',
//         value: randomInt(0.1e6, 3e6),
//     });

//     data.push({
//         id: 'inCirculation',
//         value: randomInt(0.3e6, 0.7e7),
//     });

//     return new Promise((resolve) => {
//         setTimeout(() => {
//             resolve(data);
//         }, 500);
//     });
// }

export async function fetchProductTopStatistics(
    from: Date,
    to: Date,
    dateType: DashboardDateType,
): Promise<ProductTopRecord[]> {
    const data: ProductTopRecord[] = [];
    for (let i = 0; i < randomInt(10, 25); i++) {
        data.push({
            name: faker.name.firstName() + (Math.random() > 0.5 ? ` ${faker.name.lastName()}` : ''),
            value: randomInt(1e5, 1e7),
        });
    }
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data);
        }, 500);
    });
}

// export async function fetchProductDefectStatistics(
//     from: Date,
//     to: Date,
//     dateType: DashboardDateType,
// ): Promise<ProductDefectRecord[]> {
//     const data: ProductDefectRecord[] = [];

//     if (dateType === DashboardDateType.Day) {
//         for (let d = new Date(from); d < to; d.setTime(d.getTime() + 60 * 60 * 1000)) {
//             data.push({
//                 date: formatDate(d, 'HH:mm'),
//                 value: randomInt(0, 1e5),
//                 originalDate: new Date(d),
//             });
//         }
//     } else if (dateType === DashboardDateType.Quarter) {
//         for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 7)) {
//             d.setDate(d.getDate() + 7);
//             data.push({
//                 date: `${formatDate(d, 'dd.MM')}`,
//                 value: randomInt(0, 1e5),
//                 originalDate: new Date(d),
//             });
//         }
//     } else {
//         for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
//             data.push({
//                 date: formatDate(d, 'dd.MM'),
//                 value: randomInt(0, 1e5),
//                 originalDate: new Date(d),
//             });
//         }
//     }

//     return new Promise((resolve) => {
//         setTimeout(() => {
//             resolve(data);
//         }, 500);
//     });
// }

// PROFILE
const PROFILE_URL = '/service/profile';

export async function fetchFactoryLinesList(id: string): Promise<FactoryLineStatus[]> {
    const data: FactoryLineStatus[] = [];
    for (let i = 0; i < randomInt(2, 20); i++) {
        data.push({
            id: Number(id),
            factoryId: randomInt(1, 999),
            name: faker.commerce.department(),
            code: String(randomInt(100, 9999)),
            active: faker.helpers.randomize([true, false]),
            productName: faker.commerce.productName(),
        });
    }

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data);
        }, 500);
    });
}

const mockFactoryLine = () => ({
    id: randomInt(1, 999),
    factoryId: randomInt(1, 99),
    code: String(randomInt(100, 9999)),
    name: faker.internet.userName(),
    productName: faker.commerce.productName(),
    lastActivityTime: faker.date.past(),
    productsCount: randomInt(0, 1e7),
    packsCount: randomInt(0, 1e6),
    defectPercentage: randomInt(1, 50),
    active: faker.helpers.randomize([true, false]),
});

// export async function fetchFactory(id: string): Promise<Factory> {
//     const lines: {
//         id: number;
//         factoryId: number;
//         code: string;
//         name: string;
//         productName: string;
//         lastActivityTime: Date;
//         productsCount: number;
//         packsCount: number;
//         defectPercentage: number;
//         active: boolean;
//     }[] = [];
//     for (let i = 0; i < randomInt(0, 20); i++) {
//         lines.push(mockFactoryLine());
//     }
//     return new Promise((resolve) => {
//         setTimeout(() => {
//             resolve({
//                 id: Number(id),
//                 name: `BAT - ${faker.address.city()}`,
//                 manufacturerId: randomInt(1, 999),
//                 code: String(randomInt(100, 9999)),
//                 address: `${faker.address.country()}, ${faker.address.city()}, ${faker.address.streetName()} ${randomInt(
//                     1,
//                     200,
//                 )}`,
//                 factoryLines: lines,
//             });
//         }, 500);
//     });
// }

export async function fetchFactoryLineDynamicStatistics(
    id: number,
    from: Date,
    to: Date,
): Promise<FactoryLineStatisticsRecord[]> {
    const data: FactoryLineStatisticsRecord[] = [];
    const a: Array<{x: string; y: number; date: Date}> = [];

    for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
        a.push({
            x: formatDate(d, 'dd.MM.yy'),
            y: randomInt(1000, 50000),
            date: new Date(d),
        });
    }

    data.push({
        id: 'realized',
        data: a,
    });

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data);
        }, 500);
    });
}

// DEPRECATED
export async function fetchFactoryLineActivity(id: number): Promise<FactoryLineActivityRecord[]> {
    const data: FactoryLineActivityRecord[] = [];

    for (let i = 0; i < randomInt(20, 200); i++) {
        const d = new Date();
        d.setMinutes(d.getMinutes() - i * 15);
        data.push({
            date: formatDate(d),
            isActive: faker.helpers.randomize([true, false]),
        });
    }

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data);
        }, 500);
    });
}

// export async function virtualWarehouseGrid(params: any): Promise<VirtualWarehouseGridRawRow[]> {
//     const dataLength = params.paging.pageSize;
//
//     const data: VirtualWarehouseGridRawRow[] = new Array(dataLength).fill(0).map(() => ({
//         productName: faker.name.title(),
//         gtin: '11111111111111',
//         income: randomInt(10, 10e4),
//         expense: randomInt(10, 10e4),
//         balance: randomInt(10e3, 10e6),
//     }));
//
//     return new Promise((resolve) => setTimeout(() => resolve(data), 1000));
// }

export async function virtualWarehouseGridCount(params: {filters: ApiFilters}): Promise<number> {
    return new Promise((resolve) => setTimeout(() => resolve(randomInt(5, 1000)), 1000));
}
